import { Fields, MultiSelectFieldSettings } from "@react-awesome-query-builder/core";
import { BaseSimpleField } from "../interfaces/versionInterfaces";

const createFields = (columns) => {
    const finalFields: Fields = {};
    columns.forEach((column: any) => {
        const finalColumnObj: any = {
            type: '',
            label: column.name || '',
            valueSources: ['value'],
        };
        switch (column.dataType) {
            case 'string':
                finalColumnObj.type = 'text';
                break;

            default:
                finalColumnObj.type = column.dataType;
                break;
        }
        if (column.columnType === 'master') {
            finalColumnObj.type = 'select';
            finalColumnObj.fieldSettings = {
                listValues: column.master,
            } as MultiSelectFieldSettings;
        }

        finalFields[column.name] = finalColumnObj;
    });
    return finalFields;
};

export default createFields